var map = {
	"./2019-04-01-welcome.md": 575
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 574;


//////////////////
// WEBPACK FOOTER
// ./src/_posts nonrecursive ./node_modules/markdown-with-front-matter-loader .md$
// module id = 574
// module chunks = 0